import React from "react";
import {useStyles} from "../styles/EvenDialogueGenerateSentenceStyle";
import { Box, Select, MenuItem, FormControl, IconButton } from "@material-ui/core";
import {inject, observer} from "mobx-react";
import {withRouter} from "react-router-dom";
import {ReactComponent as ArrowDownIcon} from '../../../../../../common/images/ArrowDownIcon.svg';
import {ReactComponent as RefreshIcon} from "../../../../../../common/images/RefreshIcon.svg";
import { ReactComponent as RefreshDisableIcon } from '../../../../../../common/images/RefreshDisableIcon.svg';
import {ReactComponent as VolumeIcon} from "../../../../../../common/images/VolumeIcon.svg";
import {ReactComponent as AddTextBoxIcon} from "../../../../../../common/images/AddTextBoxIcon.svg";
import { ReactComponent as DeleteTextBoxIcon } from '../../../../../../common/images/DeleteTextBoxIcon.svg';
import TextField from "@material-ui/core/TextField";
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";

function EvenDialogueSentence(props) {
    const classes = useStyles();
    const {selectedContent, evenStepOneStore, contentStore} = props;
    const {contents} = selectedContent;
    const {sentenceDialogueRoles, contentList} = evenStepOneStore;

    const onDragEnd = (result) => {
        if (!result.destination) return;
        contentList.forEach(cl => {
            const reorderedContents = Array.from(cl.contents);
            const [reorderedItem] = reorderedContents.splice(result.source.index, 1);
            reorderedContents.splice(result.destination.index, 0, reorderedItem);
            evenStepOneStore.setReorderedContents(reorderedContents, cl.languageCode);
        });
    };

    const addDialogue = () => {
        contentList.forEach(cl => {
            const reorderedContents = Array.from(cl.contents);
            reorderedContents.splice(1, 0, {speakerName: '', text: '', voiceType: ''});
            evenStepOneStore.setReorderedContents(reorderedContents, cl.languageCode);
        });
    }

    const removeDialogue = () => {
        evenStepOneStore.setDeleteFlag(true);
        contentList.forEach(cl => {
            const reorderedContents = Array.from(cl.contents);
            reorderedContents.splice(cl.contents.length-1, 1);
            evenStepOneStore.setReorderedContents(reorderedContents, cl.languageCode);
        });
    }

    const handleChangeRole = (value, index) => {
        evenStepOneStore.setDialogueContentRole(value, index);
    }

    const handleChangeDialogueText = (value, index) => {
        evenStepOneStore.setDialogueContentText(value, index, contents);
    }

    const handleChangeAudio = (voiceType, text, index) => {
        contentStore.getGeneratedTTSWithAzure(selectedContent.languageCode, voiceType, text, (result) => evenStepOneStore.setDialogueContentAudio(result, index, contents));
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {contents?.map((content, key) => (
                            <Draggable
                                key={key}
                                draggableId={`item-${key}`}
                                index={key}
                            >
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >
                                        <Box
                                            display={"flex"}
                                            alignItems={"center"}
                                            justifyContent={"flex-start"}
                                        >
                                            <Box>
                                                <FormControl className={classes.formControl}>
                                                    <Select
                                                        value={content.speakerName}
                                                        onChange={(e) => handleChangeRole(e.target.value, key)}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin: {
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            // getContentAnchorEl: null,
                                                            className: classes.selectPopover
                                                        }}
                                                        // onBlur={this.handleDomainBoxFocusOut2}
                                                    >
                                                        {!!sentenceDialogueRoles.length && sentenceDialogueRoles.map((role, i) =>
                                                            <MenuItem value={role.speakerName} key={i}>{role.speakerName}</MenuItem>
                                                        )}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                            <Box>
                                                {content.audioExist ?
                                                    <IconButton style={{cursor: 'default'}} className={classes.iconButton} disableRipple>
                                                        <RefreshDisableIcon/>
                                                    </IconButton> :
                                                    <IconButton className={classes.iconButton} disableRipple onClick={() => handleChangeAudio(content.voiceType, content.text, key)}>
                                                        <RefreshIcon/>
                                                    </IconButton>
                                                }
                                            </Box>
                                            <Box>
                                                <Box className={classes.textListBox}>
                                                    <TextField
                                                        className={classes.textField}
                                                        fullWidth
                                                        onChange={(e) => handleChangeDialogueText(e.target.value, key)}
                                                        placeholder={'대화문을 입력해주세요.'}
                                                        value={content.text}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                    />
                                                    <IconButton className={classes.volumeIconButton}
                                                                onClick={() => evenStepOneStore.playAudio(content.audio, selectedContent.languageCode+'-'+content.sequence)}
                                                                disableRipple>
                                                        <VolumeIcon/>
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                            <Box>
                                                {key === 0 ?
                                                    <IconButton className={classes.iconButton} disableRipple onClick={addDialogue}>
                                                        <AddTextBoxIcon/>
                                                    </IconButton> :
                                                    key === contents.length - 1 &&
                                                    <IconButton className={classes.iconButton} disableRipple onClick={removeDialogue}>
                                                        <DeleteTextBoxIcon />
                                                    </IconButton>
                                                }

                                            </Box>
                                        </Box>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}

export default withRouter(inject('evenStepOneStore', 'contentStore')(observer(EvenDialogueSentence)));
